/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-01, 14:29:05
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import { mapActions, mapGetters } from 'vuex';
import MobileMenu from '@/components/Panel/TopMenu/MobileMenu';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'TopMenu',

  components: { MobileMenu },

  props: ['subscriber', 'brandLogos'],

  data() {
    return {
      currentPageTitleMap: {
        MyAccount: 'Moje konto',
        Recharges: 'Doładowania',
        PaymentsAndInvoices: 'Płatności',
        Billing: 'Historia połączeń',
        Complains: 'Zgłoszenia',
        Help: 'Pomoc',
        Logout: 'Wyloguj',
        Services: 'Usługi',
      },
      menuSheme: [
        {
          name: 'MyAccount',
          icon: 'user-circle-o',
          templateName: 'Moje konto',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
        {
          name: 'OccasionZone',
          icon: 'user-circle-o',
          templateName: 'Strefa Okazji',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
        {
          name: 'Recharges',
          icon: 'download',
          templateName: 'Doładowania',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
        {
          name: 'PaymentsAndInvoices',
          icon: 'file-text',
          templateName: 'Płatności',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['postpaid'],
          isDependentOnAcl: true,
          aclPrivilege: 'can_see_payments',
        },
        {
          name: 'Billing',
          icon: 'cogs',
          templateName: 'Historia połączeń',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
        {
          name: 'Services',
          icon: 'line-chart',
          templateName: 'Usługi',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
        {
          name: 'Complains',
          icon: 'pencil-square-o',
          templateName: 'Zgłoszenia',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: true,
          aclPrivilege: 'can_see_complains',
        },
        {
          name: 'Help',
          icon: 'life-ring',
          templateName: 'Pomoc',
          isVisible: true,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
        {
          name: 'Logout',
          icon: 'sign-out',
          templateName: 'Wyloguj',
          isVisible: false,
          isOnMobileVisible: true,
          availableForAccountsType: ['prepaid', 'postpaid'],
          isDependentOnAcl: false,
          aclPrivilege: null,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['mobileMenuIsVissible', 'acl', 'brandId']),
    availableMenu() {
      return this.menuSheme.map(menu => ({
        ...menu,
        isVisible:
                    this.__menuVisibilityShouldBeVisibleDependOnAcl(menu)
                    && this.__menuVisibilityShouldBeVisibleDependOnAccountTypes(menu)
                    && this.__menuVisibilityShouldBeVisibleJustOnMobile(menu),
      }));
    },
  },

  methods: {
    ...mapActions(['logOut', 'showMobileMenu', 'hideMobileMenu']),
    __menuVisibilityShouldBeVisibleDependOnAcl(menu) {
      return menu.isDependentOnAcl ? this.acl.privileges[menu.aclPrivilege] : true;
    },
    __menuVisibilityShouldBeVisibleDependOnAccountTypes(menu) {
      return menu.availableForAccountsType.includes(this.subscriber.type);
    },
    __menuVisibilityShouldBeVisibleJustOnMobile(menu) {
      if (this.mobileMenuIsVissible) {
        return !!menu.isOnMobileVisible;
      }
      return !!menu.isVisible;
    },
    changeUrl(pathObject) {
      const { name, params } = pathObject;
      // wyjątek tymczasowy dla przkierowania Pomocy na stronę lajtmobile.pl dla brandu lajt mobile
      // zgodnie ze zgłoszeniem: DEVS-2631
      if (name === 'Help' && this.brandId === 1) {
        window.open('https://lajtmobile.pl/faq/', '_blank');
        return;
      }
      this.$router.push({ name, params }, () => {
        if (this.mobileMenuIsVissible) {
          this.toggleMenu();
        }
      });
    },
    toggleMenu() {
      if (this.mobileMenuIsVissible) {
        this.hideMobileMenu();
      } else {
        this.showMobileMenu();
      }
    },
    submitLogOut() {
      this.logOut()
                .then(() => {
                  window.location.reload();
                });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Panel/TopMenu/component.js